import axios, { isCancel, AxiosError } from "axios";
import { Preferences } from '@capacitor/preferences';
import { Capacitor, CapacitorHttp } from '@capacitor/core';

const isAbsoluteURL = (url) => {
	// A simple check to determine if the URL is absolute
	return /^(?:[a-z]+:)?\/\//i.test(url);
};

/*
const formDataToBase64 = async (formData) => {
	const entries = Array.from(formData.entries());
	const obj = await entries.reduce(async (accPromise, [key, value]) => {
		const acc = await accPromise;
		if (value instanceof File) {
			acc[key] = {
				name: value.name,
				type: value.type,
				size: value.size,
				content: await fileToBase64(value)
			};
		} else {
			acc[key] = value;
		}
		return acc;
	}, {});

	return btoa(JSON.stringify(obj));
};

const fileToBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result.split(',')[1]);
		reader.onerror = (error) => reject(error);
	});
};

const axiosCall = async (url, method, payLoad, includeToken = false, contentType = 'application/json') => {

	const headers = {
		'Content-Type': contentType
	};

	if (includeToken) {
		const token = await Preferences.get({ key: 'accessToken' });

		if (token.value) {
			headers.Authorization = `Bearer ${token.value}`;
		}
	}

	let response;

	try {

		if (Capacitor.isNativePlatform()) {

			const fullUrl = isAbsoluteURL(url) ? url : `${process.env.REACT_APP_BASE_URL}${url}`;

			const options = {
				method: method.toUpperCase(),
				url: fullUrl,
				headers: headers
			};

			// Check if the content type is multipart/form-data
			if (contentType === 'multipart/form-data') {
				const base64Data = await formDataToBase64(payLoad);
				payLoad = base64Data;
				options.headers['Content-Type'] = 'application/json';
    			options.headers['dataType'] = 'base64';
				options.headers['X-Original-Content-Type'] = 'multipart/form-data';
			}

			console.log('Native Options:', options);

			if (method.toUpperCase() === 'POST') {

				options.data = payLoad;

				response = await CapacitorHttp.post(options);

			} else if (method.toUpperCase() === 'DELETE') {

				options.data = payLoad;

				response = await CapacitorHttp.delete(options);

			} else if (method.toUpperCase() === 'PUT') {

				options.data = payLoad;

				response = await CapacitorHttp.put(options);

			} else {

				if (payLoad)
					options.params = payLoad;

				response = await CapacitorHttp.get(options);

			}

			if (response.status == 200 || response.status == 201 || response.status == 204 || response.status == 304) {
				// Success
			} else {
				throw new Error(`Native HTTP error! status: ${response.status}`);
			}

		} else {

			const api = axios.create({
				baseURL: `${process.env.REACT_APP_BASE_URL}`
			});

			console.log('URL:', url);

			if (method === "post") {
				response = await api.post(url, payLoad, { headers: headers });
			} else if (method === "put") {
				response = await api.put(url, payLoad, { headers: headers });
			} else if (method === "delete") {
				response = await api.delete(url, { data: payLoad, headers: headers });
			}
			else {
				response = await api.get(url, { headers: headers, params: payLoad });
			}
		//}

		console.log('Response:', response); // Add logging to debug

		if (response.status == 200 || response.status == 201 || response.status == 204 || response.status == 304) { 
			// Success
		} else {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return response;

	} catch (error) {

		console.log('HTTP error:', error);
		let erMessage = error.message;
		if (error.response) {
			erMessage = erMessage + ' ' + error.response?.data?.error + '. ' + error.response?.data?.detail;
		}
		throw new Error(erMessage);
	}
};
*/
const rateLimitAlertShown = false;
const refreshAccessToken = async () => {

	let refreshToken = Preferences.get({ key: 'refreshToken' });

	let result = await refreshToken.then(async function(tokenData){
		if (!tokenData.value) {
			throw new Error('No refresh token found');
		}
		const axiosApi = axios.create({
			baseURL: `${process.env.REACT_APP_BASE_URL}`,
			withCredentials: false // Disable credentials for CORS
		});
		let response = await axiosApi.post('api/token/refresh/', {'refresh': tokenData.value})
		.then((res) => {
			Preferences.set({
				key: 'accessToken',
				value: res.data.access,
			});
		}).catch((error) => {
			/* Handle error
			if (error?.response?.status === 429) {
				if (!rateLimitAlertShown) {
					alert("Please slow down, too many requests. Please wait a few seconds and try again.");
					rateLimitAlertShown = true;
				}
			}
			*/
			if (error?.response?.status === 401 || error?.response?.data?.code === 'token_not_valid') {
				// Handle token not valid error
				alert("Session expired. Please log in again.");
				Preferences.remove({ key: 'accessToken' });
				Preferences.remove({ key: 'refreshToken' });
			}
		});
	});

	return result;
};

//Axios Plugin
const axiosCall = async (url, method, payLoad, includeToken = false, contentType = 'application/json') => {
	
	const api = axios.create({
		baseURL: `${process.env.REACT_APP_BASE_URL}`,
		withCredentials: false // Disable credentials for CORS
	});

	const headers = {
		'Content-Type': contentType
	};

	let response;

	let attempts = 0;

	while (attempts < 3) {

		attempts++;

		if (includeToken) {
			const token = await Preferences.get({ key: 'accessToken' });

			if (token.value) {
				headers.Authorization = `Bearer ${token.value}`;
			}
		}

		/*
		if (includeToken) {

			var token = Preferences.get({ key: 'accessToken' });

			await token.then(async function (tokenData) {

				if (tokenData.value) {
					headers.Authorization = `Bearer ${tokenData.value}`;
				}
			});
		}
		*/

		try {

			// Native HTTP Request
			if (Capacitor.isNativePlatform() && contentType == 'multipart/form-data') {

				const fullUrl = isAbsoluteURL(url) ? url : `${process.env.REACT_APP_BASE_URL}${url}`;

				// Manually set the Content-Type with boundary
				const boundary = `----${Date.now().toString(16)}`;
				headers['Content-Type'] = `multipart/form-data; boundary=${boundary}`;
				headers['Accept'] = "application/json, text/plain, */*";

				const options = {
					method: method.toUpperCase(),
					body: payLoad,
					headers: headers,
					dataType: 'formData'
				};

				const fetchResponse = await fetch(fullUrl, options);
				const data = await fetchResponse.json();

				response = {
					status: fetchResponse.status,
					data: data
				};
				
				/*
				console.log('Native Response:', JSON.stringify(response)); // Add logging to debug
				response = await CapacitorHttp.request({
					url: fullUrl,
					dataType: 'formData',
					data: payLoad,
					method: method.toUpperCase(),
					headers: headers,
				});
				*/
				
			} else {
				const config = {
					headers,
					// Set maximum content length and timeout
					maxContentLength: Infinity,
					maxBodyLength: Infinity,
					timeout: 60000
				};

				switch(method.toLowerCase()) {
					case 'post':
						response = await api.post(url, payLoad, config);
						break;
					case 'put':
						response = await api.put(url, payLoad, config);
						break;
					case 'delete':
						response = await api.delete(url, { 
							...config,
							data: payLoad 
						});
						break;
					default: // GET
						response = await api.get(url, { 
							...config,
							params: payLoad 
						});
				}
			}

			//console.log('Response:', JSON.stringify(response.data)); // Add logging to debug

			if (![200, 201, 204, 304].includes(response.status)) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			return response;
		} catch (e) {
			if(e.response?.status === 429) {
				if (!rateLimitAlertShown) {
					alert("Please slow down, too many requests. Please wait a few seconds and try again.");
					rateLimitAlertShown = true;
				}
				throw new Error('Rate limit exceeded. Please try again later.');
			}

			if(attempts < 3 && (e.response?.status == 401 || e.response?.data?.code === 'token_not_valid')) {
				// Refresh token logic here
				await refreshAccessToken();
				continue; // Retry the request after refreshing token
			}

			// catch error
			console.log(e);
			let erMessage = e.message;
			if (e.response) {
				erMessage = erMessage + ' ' + e.response?.data?.error + '. ' + e.response?.data?.detail;
			}
			throw new Error(erMessage);
		}
	}

	throw new Error('Request failed after 3 attempts.');

};

export default axiosCall;